export default __webpack_public_path__ + "static/media/conference-budget.caf53d56.svg";